module.exports = __webpack_public_path__ + "static/chef-hero-small-22e6877d2815f69d1a8135d0fbc9cfd2.png";